import React, { Component } from 'react';
import HttpRunner from '../query';
import urlHandler from '../../../utils/urlHandler';
import perms from '../../../utils/permissions';
import examples from '../../../utils/examples';
import miscUtils from '../../../utils/miscUtils';

class DocEmailEntity extends Component {
    constructor(props){
        super(props);

        this.state = {
            dynamicSample: false
        }
    }

    componentDidMount() {
        this.setState({
            dynamicSample: perms.checkEndpoint(urlHandler.API_ENDPOINT_V2_ENRICH)
        }) 
    }

    render() {
        return (
            <div className="bucket" id="top">
                <div>
                    <h3 className="heading-1" id="email">Email</h3>

                    <div className="description">
                        The extraction of an email address is based upon the application
                        techniques for checking and transformation of names (RFC 3696) and extracts well-formed and some
                        non-standardized email addresses. In general, there must be two parts present: a local part and a
                        domain part. The domain part has specs equal to the hostname pattern and must also always have a valid
                        top-level domain. 
                    </div>
                    <br/>
                    <div className="description">
                        For well-formed or standardized email addresses; the local part contains labels consisting
                        of alphanumeric and special characters where each label separated by a dot (.). The two parts must be
                        separated by an at-sign (@).
                    </div>

                    <code className="code-snippet abstract">
                        <span className="line">{'<'}label{'>'}.{'<'}label{'>'}@{'<'}sub-domain{'>'}.{'<'}top-level-domain{'>'}</span>
                    </code>

                    <div className="description">
                        Other non-standard forms of email address patterns are recognized, and when extracted, normalize to a 
                        standard form which is provided in the 'normalizedText' attribute. A non-standard form of an email address 
                        are those where "dot" (separates labels and/or sub-domains) and "at" (separates local and domain parts) 
                        are represented as strings with optional separators (parenthesis, square-brackets, single/double quotes).
                    </div>

                    <code className="code-snippet abstract">
                        <span className="line">{'<'}label{'>'}[dot]{'<'}label{'>'}@{'<'}sub-domain{'>'}[dot]{'<'}top-level-domain{'>'}</span>
                    </code>

                    <code className="code-snippet abstract">
                        <span className="line">{'<'}label{'>'}[dot]{'<'}label{'>'}[at]{'<'}sub-domain{'>'}[dot]{'<'}top-level-domain{'>'}</span>
                    </code>

                    <div className="description">
                        An extracted email address will be represented by the following attributes:
                    </div>

                    <table className="table-wrapper">
                        <thead className="table-header">
                        <tr>
                            <th>Attribute </th>
                            <th>Meaning </th>
                            <th>Type </th>
                            <th>Constraints </th>
                            <th>Notes </th>
                        </tr>
                        </thead>

                        <tbody className="table-body">
                        <tr>
                            <td className="attribute">localPart</td>
                            <td className="meaning">Represents the local part or username of the email address.</td>
                            <td className="type">String</td>
                            <td className="constraints">Mandatory</td>
                            <td className="notes">Labels must be separated by a period or the string "dot".</td>
                        </tr>
                        <tr>
                            <td className="attribute">domain</td>
                            <td className="meaning">An object representing attributes of the domain.</td>
                            <td className="type">JSONObject</td>
                            <td className="constraints">Mandatory</td>
                            <td className="notes"></td>
                        </tr>
                        </tbody>
                    </table>

                    <div className="description">
                        A domain object will be represented by the following nested attributes:
                    </div>

                    <table className="table-wrapper">
                        <thead className="table-header">
                        <tr>
                            <th>domain Attribute </th>
                            <th>Meaning </th>
                            <th>Type </th>
                            <th>Constraints </th>
                            <th>Notes </th>
                        </tr>
                        </thead>

                        <tbody className="table-body">
                        <tr>
                            <td className="attribute">domainName</td>
                            <td className="meaning">Represents the domain name of the email address.</td>
                            <td className="type">String</td>
                            <td className="constraints">Mandatory</td>
                            <td className="notes">Must contain a valid top-level domain as specified by {miscUtils.createExternalLink('http://www.iana.org/domains/root/db', 'IANA')}. Labels
                                must be separated by a period or the string "dot"
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <h4 className="heading-2">Example</h4>
                    <div className="example-content">
                        Assistant Executive Director for Communications e-mail at: <b>mediaoffice@energy.state.ca.us</b>. Information concerning 
                        the status of the project, as well as notices and other relevant documents...
                    </div>
                    <HttpRunner example="email1" 
                        query="enrich"
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_EMAIL1) : null}
                    />
                    <h4 className="heading-2">Nonstandard Example</h4>
                    <div className="example-content">
                        Send e-mail to talk [at] alaskapublic [dot] org (comments may be read on air)...
                    </div>
                    <HttpRunner example="email2" 
                        query="enrich"
                        response={!this.state.dynamicSample ? JSON.stringify(examples.EXAMPLE_RESPONSE_EMAIL2) : null}
                    />
                </div>
            </div>
        );
    }
}

export default DocEmailEntity;